import type { UserModel } from "~/models/User.model";
import { useAuthStore } from "~/stores/auth";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const publicRoutes = [
    "/",
    "/login",
    "/register",
    "/password-recovery",
    "/contact",
    "/faq",
    "/impressum",
    "/partners",
    "/press",
    "/roadmap",
    "/status",
    "/team",
    "/icons",
    "/health-check",
    "/qa-sidebar-preview",
    "/esignature",
  ];

  const { $i18n } = useNuxtApp();
  const $localePath = useLocalePath();
  const locales = ($i18n.locales.value as any[]).map((l) => (typeof l === "string" ? l : l.code));
  const localeRegex = new RegExp(`^/(${locales.join("|")})/?`);

  const normalizedPath = to.path.replace(localeRegex, "/").replace(/\/$/, "") || "/";

  const isPublicRoute = publicRoutes.some((route) => {
    return normalizedPath === route || normalizedPath.startsWith(route + "/");
  });

  if (isPublicRoute) {
    return;
  }

  const authStore = useAuthStore();
  const user: UserModel = await authStore.getUser();

  if (!user?.id) {
    return navigateTo({
      path: $localePath("/login"),
      query: from.query,
    });
  }
});
